import React from 'react';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import BaseSubnav, { SubnavGroup } from './BaseSubnav';
import { getPublicPath } from 'utils/paths';

const NewTopbarTalentSubnav: React.FC = () => {
  const { t } = useI18n('topbar');
  const { locale } = useRouter();

  const illustration = getPublicPath('/images/topbar/talent-circle.svg');

  const groups: SubnavGroup[] = [
    {
      title: t('talent_subnav.profile.title'),
      items: [
        {
          text: t('talent_subnav.profile.profile.title'),
          href: `${getAppUrl(APP_URLS.talent, locale)}#professional_profile`
        }
      ]
    },
    {
      title: t('talent_subnav.search.title'),
      items: [
        {
          text: t('talent_subnav.search.offers.title'),
          href: `${getAppUrl(APP_URLS.jobOffers, locale)}`
        },
        {
          text: t('talent_subnav.search.teams.title'),
          href: `${getAppUrl(APP_URLS.manfredDaily, locale)}`
        }
      ]
    },
    {
      title: t('talent_subnav.growth.title'),
      items: [
        {
          text: t('companies_subnav.resources.guia-salarial.title'),
          href: `${getAppUrl(
            APP_URLS.blog,
            locale
          )}/guia-salarial-2026-salarios-en-tecnologia-espana-manfred`
        },
        {
          text: t('talent_subnav.growth.tech-career-report.title'),
          href: `${getAppUrl(APP_URLS.mantechcar25, locale)}`
        },
        {
          text: t('talent_subnav.growth.benchmark.title'),
          href: `${getAppUrl(APP_URLS.salaryCompass, locale)}`
        },
        {
          text: t('talent_subnav.growth.helping-juniors.title'),
          href: `${getAppUrl(APP_URLS.helpingJuniors, locale)}`
        }
      ]
    }
  ];

  return (
    <BaseSubnav
      illustration={illustration}
      title={t('talent_subnav.ally.title')}
      description={t('talent_subnav.ally.desc')}
      cta={{
        text: t('talent_subnav.ally.link'),
        href: getAppUrl(APP_URLS.talent, locale)
      }}
      groups={groups}
    />
  );
};

export default NewTopbarTalentSubnav;
